export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  MultiColumnSorting,
} from './multiColumnSorting';
